export default {"src":"/_next/static/media/defaultBigIndustrial.98257431.svg","height":125,"width":218};